class CartNotification extends HTMLElement {
  constructor() {
    super();
    this.notification = document.getElementById('cart-notification');
  }

  open() {
    this.notification.classList.add('active');

    setTimeout(() => {
      this.close();
    }, 3500);
  }

  close() {
    this.notification.classList.remove('active');
  }

  renderContents(parsedState) {
      this.cartItemKey = parsedState.key;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-content',
        selector: `[id="cart-notification-content-${this.cartItemKey}"]`,
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}
customElements.define('cart-notification', CartNotification);
